<span class="plus basket-add" tabindex="0" data-toggle="modal" data-target="#addBasket" title="Add current document to Basket. Then click on Basket icon at the top to pay and download.">&nbsp;&nbsp;Add to Basket</span>
<div class="modal fade" id="addBasket" tabindex="-1" role="dialog" aria-labelledby="addToBasket" aria-hidden="true">
  <div class="modal-dialog add-bskt" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addToBasket">Add to Download list...</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <button type="button" (click)="addToBasket(true)" data-dismiss="modal">Whole Document</button>
        <button type="button" (click)="addToBasket(false)" data-dismiss="modal">This Page</button>
      </div>
    </div>
  </div>
</div>
<dx-popup [width]="350"
          [height]="150"
          [showTitle]="true"
          title="Information"
          [dragEnabled]="false"
          [closeOnOutsideClick]="true"
          [(visible)]="popupVisible">
  <div>
    <p>
      {{Message}}
    </p>

  </div>
</dx-popup>
